import React from 'react';
import { Section } from './ui/Section';
import { Calendar, Clock, Repeat, ChefHat, AlertTriangle, ArrowRightLeft } from 'lucide-react';
export function HowToUse() {
  return <Section data-id="element-60">
      <h2 className="text-3xl font-bold mb-10 text-center" data-id="element-61">
        Cómo se usa (en la vida real)
      </h2>

      <div className="space-y-8" data-id="element-62">
        {/* Sunday */}
        <div className="relative pl-8 border-l-2 border-sage/30 pb-8" data-id="element-63">
          <div className="absolute -left-[17px] top-0 w-8 h-8 bg-sage text-white rounded-full flex items-center justify-center" data-id="element-64">
            <Calendar className="w-4 h-4" data-id="element-65" />
          </div>
          <h3 className="text-xl font-bold mb-4" data-id="element-66">Domingo: 30 minutos.</h3>
          <ul className="space-y-3" data-id="element-67">
            <li className="flex items-center gap-3 text-brown-body" data-id="element-68">
              <Clock className="w-4 h-4 text-sage" data-id="element-69" />
              elegís una versión de menú
            </li>
            <li className="flex items-center gap-3 text-brown-body" data-id="element-70">
              <CopyIcon className="w-4 h-4 text-sage" data-id="element-71" />
              copiás la lista
            </li>
            <li className="flex items-center gap-3 text-brown-body" data-id="element-72">
              <ChefHat className="w-4 h-4 text-sage" data-id="element-73" />
              hacés 2–3 mini-preps
            </li>
          </ul>
        </div>

        {/* Weekdays */}
        <div className="relative pl-8 border-l-2 border-sage/30" data-id="element-74">
          <div className="absolute -left-[17px] top-0 w-8 h-8 bg-white border-2 border-sage text-sage rounded-full flex items-center justify-center" data-id="element-75">
            <Repeat className="w-4 h-4" data-id="element-76" />
          </div>
          <h3 className="text-xl font-bold mb-4" data-id="element-77">Lunes a viernes:</h3>
          <ul className="space-y-3" data-id="element-78">
            <li className="flex items-center gap-3 text-brown-body" data-id="element-79">
              <Repeat className="w-4 h-4 text-sage" data-id="element-80" />
              repetís combinaciones
            </li>
            <li className="flex items-center gap-3 text-brown-body" data-id="element-81">
              <ArrowRightLeft className="w-4 h-4 text-sage" data-id="element-82" />
              usás swaps si falta algo
            </li>
            <li className="flex items-center gap-3 text-brown-body" data-id="element-83">
              <AlertTriangle className="w-4 h-4 text-sage" data-id="element-84" />
              aplicás plan de emergencia si te quedaste sin tiempo
            </li>
          </ul>
        </div>
      </div>

      <div className="text-center mt-12" data-id="element-85">
        <p className="text-2xl font-serif font-bold text-brown-heading" data-id="element-86">
          Eso es.
        </p>
      </div>
    </Section>;
}
function CopyIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-87">
      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" data-id="element-88" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" data-id="element-89" />
    </svg>;
}